import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ThemeContextProvider from './style/theme'; // Import the ThemeContextProvider
import ReferralTracker from "./utilities/ReferralTracker";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ThemeContextProvider> 
      <ReferralTracker/>
      <App />
    </ThemeContextProvider>
  </BrowserRouter>
);
